"use client"

import type React from "react"
import { useState, useEffect } from "react"
import { Button, useMediaQuery, useTheme, Fade } from "@mui/material"
import { IconPencil } from "@tabler/icons-react"

interface CustomOrderButtonProps {
    onClick: () => void
}

const CustomOrderButton: React.FC<CustomOrderButtonProps> = ({ onClick }) => {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("md"))
    const [isVisible, setIsVisible] = useState(true)
    const [isScrolling, setIsScrolling] = useState(false)

    // Detectar cuando el botón está sobre el footer
    useEffect(() => {
        const handleScroll = () => {
            const footer = document.querySelector("footer")
            if (!footer) return

            const footerRect = footer.getBoundingClientRect()
            const windowHeight = window.innerHeight
            const buttonHeight = 48 // Altura aproximada del botón
            const buttonMargin = 30 // Margen inferior del botón

            // Calcular la posición del botón desde la parte superior de la ventana
            const buttonTopPosition = windowHeight - buttonHeight - buttonMargin

            // Si el footer está visible y el botón lo tocaría
            if (footerRect.top <= buttonTopPosition) {
                setIsVisible(false)
            } else {
                setIsVisible(true)
            }

            // Detectar si está scrolleando para evitar parpadeos
            if (!isScrolling) {
                setIsScrolling(true)
                setTimeout(() => setIsScrolling(false), 100)
            }
        }

        window.addEventListener("scroll", handleScroll)
        handleScroll() // Comprobar posición inicial

        return () => {
            window.removeEventListener("scroll", handleScroll)
        }
    }, [isScrolling])

    return (
        <Fade in={isVisible} timeout={300}>
            <Button
                variant="contained"
                color="primary"
                onClick={onClick}
                startIcon={<IconPencil size={20} />}
                sx={{
                    position: "fixed",
                    bottom: 30,
                    right: 30,
                    backgroundColor: "#0d6336",
                    color: "white",
                    borderRadius: "30px",
                    padding: isMobile ? "8px 16px" : "10px 20px",
                    minWidth: "auto",
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                    "&:hover": {
                        backgroundColor: "#3c2a20",
                    },
                    zIndex: 99,
                    transition: "all 0.3s ease",
                    fontSize: isMobile ? "0.875rem" : "1rem",
                }}
            >
                {isMobile ? "Cuadrito Personalizado" : "Solicitar cuadrito personalizado"}
            </Button>
        </Fade>
    )
}

export default CustomOrderButton

